import * as React from 'react';
import { LinkPreview } from '@epihub/web/src/tailwind/components/LinkPreview';
import { useSfyr } from '../_ctx/sfyr';
import { styled } from '../theme/theme';
import {
  LottieFacebook,
  LottieGithub,
  LottieInstagram,
  LottieLinkedin,
  LottieMedium,
  LottieTelegram,
  LottieTwitter,
} from './Lottie';

export const SocialBar = () => {
  const sfyr = useSfyr();
  return (
    <Root>
      <IconWrapper
        target='_blank'
        url={sfyr('ui.social.{type=instagram}.url', {
          defaults: {
            'ui.social.{type=instagram}.url': 'https://www.instagram.com/krishanmarco',
          },
        })}
      >
        <StyledLottieInstagram />
      </IconWrapper>
      <IconWrapper
        target='_blank'
        url={sfyr('ui.social.{type=linkedin}.url', {
          defaults: {
            'ui.social.{type=linkedin}.url': 'https://www.linkedin.com/in/krishanmarco',
          },
        })}
      >
        <StyledLottieLinkedin />
      </IconWrapper>
      <IconWrapper
        target='_blank'
        url={sfyr('ui.social.{type=telegram}.url', {
          defaults: {
            'ui.social.{type=telegram}.url': 'https://t.me/krishanmarco',
          },
        })}
      >
        <StyledLottieTelegram />
      </IconWrapper>
      <IconWrapper
        target='_blank'
        url={sfyr('ui.social.{type=twitter}.url', {
          defaults: {
            'ui.social.{type=twitter}.url': 'https://twitter.com/krishanmarco',
          },
        })}
      >
        <StyledLottieTwitter />
      </IconWrapper>
      <IconWrapper
        target='_blank'
        url={sfyr('ui.social.{type=facebook}.url', {
          defaults: {
            'ui.social.{type=facebook}.url': 'https://www.facebook.com/krishanmarco',
          },
        })}
      >
        <StyledLottieFacebook />
      </IconWrapper>
      <IconWrapper
        target='_blank'
        url={sfyr('ui.social.{type=github}.url', {
          defaults: {
            'ui.social.{type=github}.url': 'https://www.github.com/krishanmarco',
          },
        })}
      >
        <StyledLottieGithub />
      </IconWrapper>
      <IconWrapper
        target='_blank'
        url={sfyr('ui.social.{type=medium}.url', {
          defaults: {
            'ui.social.{type=medium}.url': 'https://epilogosrl.medium.com',
          },
        })}
      >
        <StyledLottieMedium />
      </IconWrapper>
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  flex-direction: row;
`;

const IconWrapper = styled(LinkPreview)`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export function styleSocialIcon(Comp: React.FC<any>): React.FC {
  return styled(Comp)`
    margin-left: -10px;
    margin-right: 10px;
    width: 50px;
  `;
}

const StyledLottieInstagram = styleSocialIcon(LottieInstagram);
const StyledLottieLinkedin = styleSocialIcon(LottieLinkedin);
const StyledLottieTelegram = styleSocialIcon(LottieTelegram);
const StyledLottieTwitter = styleSocialIcon(LottieTwitter);
const StyledLottieFacebook = styleSocialIcon(LottieFacebook);
const StyledLottieMedium = styled(styleSocialIcon(LottieMedium))`
  width: 38px;
  margin-top: -4px;
  margin-left: 0;
`;
const StyledLottieGithub = styled(styleSocialIcon(LottieGithub))`
  width: 32px;
  margin-top: -7px;
  margin-left: -5px;
`;
